import React, { Component } from 'react'
import {
  BookingHeader,
  BookingDate,
  BookingRow,
  MoreButton
} from './bookingSchemeComponents'
import { parseDate } from '../../helpers/Functions'

class BookingScheme extends Component {
  constructor(props) {
    super(props)
    this.state = {
      weeks: 1
    }
  }

  renderRow(time, date) {
    const {
      laundries,
      myBookings,
      otherBookings,
      language,
      bookingPressed
    } = this.props
    const { startTime, endTime, id } = time
    return (
      <BookingRow
        time={startTime + '-' + endTime}
        laundries={laundries}
        timeId={id}
        myBookings={myBookings}
        otherBookings={otherBookings}
        date={date}
        language={language}
        bookingPressed={bookingPressed}
      />
    )
  }

  renderWeeks() {
    const { weeks } = this.state
    const { times, laundries, startDate } = this.props
    let content = []
    const days = weeks * 7
    for (let i = 0; i < days; i++) {
      content = [
        ...content,
        <BookingDate date={parseDate(startDate)} laundries={laundries} />
      ]
      //eslint-disable-next-line
      times.forEach(time => {
        content = [...content, this.renderRow(time, parseDate(startDate))]
      })
      startDate.setDate(startDate.getDate() + 1)
    }
    return content
  }

  renderMoreButton() {
    const { weeks } = this.state
    const { bookingRange } = this.props.laundryRules
    if (bookingRange !== 0 && weeks >= bookingRange) return null
    return <MoreButton onClick={() => this.setState({ weeks: weeks + 1 })} />
  }

  render() {
    const { containerStyle } = styles
    const { laundryRules, laundries, language } = this.props
    if (laundryRules === null) return null
    return (
      <div className={'ShadowContainer'} style={containerStyle}>
        <BookingHeader
          laundries={laundries}
          laundryRules={laundryRules}
          language={language}
        />
        {this.renderWeeks()}
        {this.renderMoreButton()}
      </div>
    )
  }
}

const styles = {
  containerStyle: {
    minWidth: '90%',
    display: 'flex',
    flexDirection: 'column',
    marginBottom: 100
  }
}

export { BookingScheme }



// WEBPACK FOOTER //
// ./src/components/common/BookingScheme.js